import { ActionMessages, ACTIONS } from '@root/src/types/common';
import { DedicatedForumFront, DedicatedForumParticipantFront } from './types';

type ForumMessageData =
  | DedicatedForumFront
  | DedicatedForumParticipantFront
  | (DedicatedForumParticipantFront & { forumTopic: string })
  | undefined
  | null;

const safeFormat = (data: ForumMessageData) => ({
  forumTopic:
    data != null && 'forumTopic' in data ? data.forumTopic : data != null && 'topic' in data ? data.topic : '',
  participantName:
    data != null && 'user' in data
      ? `${(data as DedicatedForumParticipantFront).user.firstName} ${(data as DedicatedForumParticipantFront).user.lastName}`
      : '',
});

export const dedicatedForumActionMessages: ActionMessages<DedicatedForumFront | DedicatedForumParticipantFront> = {
  [ACTIONS.CREATE]: {
    successTitleKey: 'api.dedicatedForum.create.successTitle',
    successDescriptionKey: 'api.dedicatedForum.create.successDescription',
    formatMessage: (data: DedicatedForumFront | DedicatedForumParticipantFront) => ({
      ...safeFormat(data),
    }),
  },
  [ACTIONS.UPDATE]: {
    successTitleKey: 'api.dedicatedForum.update.successTitle',
    successDescriptionKey: 'api.dedicatedForum.update.successDescription',
    formatMessage: (data: DedicatedForumFront | DedicatedForumParticipantFront) => ({
      ...safeFormat(data),
    }),
  },
  [ACTIONS.ADD]: {
    successTitleKey: 'api.dedicatedForum.add.successTitle',
    successDescriptionKey: 'api.dedicatedForum.add.successDescription',
    formatMessage: (
      data:
        | DedicatedForumFront
        | DedicatedForumParticipantFront
        | (DedicatedForumParticipantFront & { forumTopic: string }),
    ) => safeFormat(data),
  },
  [ACTIONS.DELETE]: {
    successTitleKey: 'api.dedicatedForum.delete.successTitle',
    successDescriptionKey: 'api.dedicatedForum.delete.successDescription',
    formatMessage: (data: DedicatedForumFront | DedicatedForumParticipantFront) => safeFormat(data),
  },
};
